import React from 'react';

import { usePlanStateField } from 'scenes/MarketingPlanning/MarketingPlanningWizard/components/PlanState';
import { COMMENT } from 'scenes/MarketingPlanning/MarketingPlanningWizard/constants';

import { HighLightTextField } from './components';

export const Comment = props => {
  const { value, onChange } = usePlanStateField(COMMENT);

  const [commentText, setCommentText] = React.useState(value);

  React.useEffect(() => {
    setCommentText(value);
  }, [value]);

  const handleChange = React.useCallback((_e, value) => {
    setCommentText(value);
  }, []);

  const handleBlur = React.useCallback(() => {
    setCommentText(value => {
      onChange(null, value);
      return value;
    });
  }, []);

  return (
    <HighLightTextField
      value={commentText}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={'Comment'}
      width={'190px'}
      {...props}
    />
  );
};
